import React, { useState } from "react";

const OverflowWrapper = (props: { children: any, className?: string, disableExpand?: boolean }) => {
  const [hover, setHover] = useState(false);
  const [open, setOpen] = useState(true);

  return (
    <div className="relative">
      <div className={`overflow-container transition-all overflow-hidden relative mb-3 ${ open ? "max-h-128" : "max-h-52"} ${ props.className }`}>
        { props.children }
      </div>
      {
        <div 
          className={`absolute -bottom-4 bg-white left-0 right-0 w-full cursor-pointer hover:text-red`}
          onMouseEnter={(e) => {
            setHover(true);
          }} 
          onMouseLeave={(e) => {
            setHover(false);
          }} 
          onClick={(e) => {
            setOpen(!open);
          }}
          onKeyDown={(e) => {
            if(e.key === "Enter") {
              setOpen(!open);
            }
          }}
          role="button"
          tabIndex={0}
          aria-label="Toggle overflow content"
        >
          {
            props.disableExpand ||
            <p className={`text-sm text-center w-full pt-2 ${ hover ? "opacity-100" : "opacity-40" }`}>
              Show { open ? "Less" : "More" } Options
            </p>
          }
        </div>
      }
    </div>
  )
}

export default OverflowWrapper;